import { render, staticRenderFns } from "./radio-defaultValue-editor.vue?vue&type=template&id=10367e38&scoped=true"
import script from "./radio-defaultValue-editor.vue?vue&type=script&lang=js"
export * from "./radio-defaultValue-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10367e38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10367e38')) {
      api.createRecord('10367e38', component.options)
    } else {
      api.reload('10367e38', component.options)
    }
    module.hot.accept("./radio-defaultValue-editor.vue?vue&type=template&id=10367e38&scoped=true", function () {
      api.rerender('10367e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-radio/radio-defaultValue-editor.vue"
export default component.exports